import React, { useMemo } from 'react';
import { Popover, Tooltip } from 'udesk-ui';
import { getRandomColor } from 'src/util/color';
import './style.scss';
import UdeskLocales from 'UdeskLocales';

interface Times {
    startPoint: number;
    endPoint: number;
    emotionValue?: string | number;
    sentenceListIndex: number;
    tagsNum: number;
    color: string;
    title?: string;
}

interface RoleTimes {
    type: 'agent' | 'customer' | 'topic';
    label?: string;
    voiceLength: number;
    times: Times[];
}

const AUDIO_STICKER_COLORS = ['#BDDEFF', '#ABEDAB'];

const AudioStickers = (props) => {
    const {
        dialogSentenceList,
        voiceLength,
        indexPointTag,
        smartTags,
        detailShowConfigObj,
        recogniseDetail = {},
    } = props;

    const audioStickers = useMemo(() => {
        let agentTimes: RoleTimes = {
            type: 'agent',
            label: /* 客服 */ UdeskLocales['current'].components.audioStickersTalkV2.index
                .customerService,
            voiceLength: voiceLength,
            times: [],
        };
        let customerTimes: RoleTimes = {
            type: 'customer',
            label: /* 客户 */ UdeskLocales['current'].components.audioStickersTalkV2.index.customer,
            voiceLength: voiceLength,
            times: [],
        };

        dialogSentenceList.forEach((item, index) => {
            if (item.role === 'agent') {
                agentTimes.times.push({
                    startPoint: item.fromSec,
                    endPoint: item.endSec,
                    emotionValue: item.emotionValue,
                    sentenceListIndex: index,
                    tagsNum: 0,
                    color: AUDIO_STICKER_COLORS[0],
                });
            } else if (item.role === 'customer') {
                customerTimes.times.push({
                    startPoint: item.fromSec,
                    endPoint: item.endSec,
                    emotionValue: item.emotionValue,
                    sentenceListIndex: index,
                    tagsNum: 0,
                    color: AUDIO_STICKER_COLORS[1],
                });
            }
        });

        let topicTimes: RoleTimes = {
            type: 'topic',
            label: /* 话题 */ UdeskLocales['current'].components.audioStickersTalkV2.index.topic,
            voiceLength: voiceLength,
            times: (recogniseDetail.sentenceTopicDurationResults || []).map((d) => {
                return {
                    startPoint: dialogSentenceList[d.startSentenceIndex - 1].fromSec ?? 0,
                    endPoint: dialogSentenceList[d.endSentenceIndex - 1].endSec ?? 0,
                    color: getRandomColor(256),
                    title: d.topicName,
                    sentenceListIndex: -1,
                    tagsNum: 0,
                };
            }),
        };

        return [agentTimes, customerTimes, topicTimes];
    }, [dialogSentenceList, recogniseDetail.sentenceTopicDurationResults, voiceLength]);

    // 格式化数据
    const formDataSmartTags = useMemo(() => {
        let newObj = {};
        smartTags.forEach((item) => {
            // console.log(item.highlightGroups);
            if (item.highlightGroups && item.highlightGroups.length > 0) {
                for (let vo of item.highlightGroups) {
                    if (vo.highlightItemList && vo.highlightItemList.length > 0) {
                        vo.highlightItemList.forEach((el) => {
                            if (newObj[el.index - 1]) {
                                newObj[el.index - 1].push(item.categoryName);
                            } else {
                                newObj[el.index - 1] = [item.categoryName];
                            }
                        });
                    }
                }
            }
        });

        return newObj;
    }, [smartTags]);

    const formDataAllTags = useMemo(() => {
        audioStickers.map((itemAudioSticker) => {
            itemAudioSticker['times'].map((item) => {
                item.tagsNum = 0;
                if (detailShowConfigObj?.playBarShowSmartTag) {
                    if (formDataSmartTags[item.sentenceListIndex]) {
                        // console.log('addSmartTagIndex', item.sentenceListIndex);
                        item['smartTag'] = formDataSmartTags[item.sentenceListIndex];

                        if (item['smartTag']) {
                            item.tagsNum += 1;
                        }
                    }
                }
                if (detailShowConfigObj?.playBarShowPoint) {
                    if (indexPointTag[item.sentenceListIndex + 1]) {
                        let tmpArr: any = [];
                        indexPointTag[item.sentenceListIndex + 1].forEach((el: any) => {
                            if (el.name) {
                                tmpArr.push(el.name);
                            }
                        });
                        item['indexPointTag'] = tmpArr;
                    }
                    if (item['indexPointTag']) {
                        item.tagsNum += 1;
                    }
                }
                if (detailShowConfigObj?.playBarShowEmotion) {
                    if (item['emotionValue'] !== 0) {
                        item.tagsNum += 1;
                    }
                }
            });
        });
    }, [formDataSmartTags, indexPointTag, audioStickers, detailShowConfigObj]);

    const multiModel = (item, itemIndex) => {
        return (
            <>
                {detailShowConfigObj?.playBarShowEmotion ? (
                    <span style={{ cursor: 'pointer', display: 'inline-block' }}>
                        {item.emotionValue == 1 && (
                            <img
                                style={{ width: '10px', height: '10px' }}
                                src="/static/images/positive.png"
                                alt=""
                            />
                        )}
                        {item.emotionValue == 2 && (
                            <img
                                style={{ width: '10px', height: '10px' }}
                                src="/static/images/positive.png"
                                alt=""
                            />
                        )}
                        {item.emotionValue == 3 && (
                            <img
                                style={{ width: '10px', height: '10px' }}
                                src="/static/images/positive.png"
                                alt=""
                            />
                        )}
                        {item.emotionValue == -1 && (
                            <img
                                style={{ width: '10px', height: '10px' }}
                                src="/static/images/negative.png"
                                alt=""
                            />
                        )}
                        {item.emotionValue == -2 && (
                            <img
                                style={{ width: '10px', height: '10px' }}
                                src="/static/images/negative.png"
                                alt=""
                            />
                        )}
                        {item.emotionValue == -3 && (
                            <img
                                style={{ width: '10px', height: '10px' }}
                                src="/static/images/negative.png"
                                alt=""
                            />
                        )}
                    </span>
                ) : (
                    ''
                )}
                <span
                    style={{ cursor: 'pointer', display: 'inline-block', marginLeft: '10px' }}
                    // onClick={() => {
                    //     alert(itemIndex);
                    // }}
                >
                    {item['indexPointTag'] && (
                        <Tooltip placement="top" title={item['indexPointTag'].join(',') || ''}>
                            <img
                                style={{ width: '14px', height: '14px' }}
                                src="/static/images/rulesTag.png"
                                alt=""
                            />
                        </Tooltip>
                    )}
                </span>

                <span
                    style={{ cursor: 'pointer', display: 'inline-block', marginLeft: '10px' }}
                    // onClick={() => {
                    //     alert(itemIndex);
                    // }}
                >
                    {item['smartTag'] && (
                        <Tooltip placement="top" title={item['smartTag'].join(',') || ' '}>
                            <img
                                style={{ width: '14px', height: '14px' }}
                                src="/static/images/qaRules.png"
                                alt=""
                            />
                        </Tooltip>
                    )}
                </span>
            </>
        );
    };

    console.log('AudioStickers:formDataAllTags', formDataAllTags, audioStickers);

    return (
        <div className="audio-stickers-talk-v2">
            {audioStickers.map((audioSticker, index) => {
                return (
                    <div style={{ display: 'flex' }}>
                        <div
                            style={{
                                flexBasis: 40,
                                fontSize: 12,
                                textAlign: 'center',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis',
                                overflow: 'hidden',
                            }}
                            title={audioSticker.label}
                        >
                            {audioSticker.label}
                        </div>

                        <div key={index} className="audio-sticker-view">
                            {audioSticker.times.map((item, itemIndex) => {
                                return (
                                    <div>
                                        <div
                                            key={itemIndex}
                                            className="audio-sticker-item"
                                            style={getAudioStickerItemStyleModel(
                                                item.startPoint,
                                                item.endPoint,
                                                audioSticker.voiceLength,
                                                item.color
                                            )}
                                        >
                                            {audioSticker.type === 'topic' ? (
                                                <Tooltip
                                                    title={
                                                        <div style={{ whiteSpace: 'pre-wrap' }}>
                                                            {item.title}
                                                        </div>
                                                    }
                                                >
                                                    <div
                                                        style={{
                                                            height: '100%',
                                                            cursor: 'pointer',
                                                        }}
                                                    ></div>
                                                </Tooltip>
                                            ) : item.tagsNum > 1 ? (
                                                <span style={{ cursor: 'pointer' }}>
                                                    <Popover
                                                        placement="right"
                                                        content={multiModel(item, itemIndex)}
                                                    >
                                                        <img
                                                            style={{
                                                                width: '10px',
                                                                height: '10px',
                                                            }}
                                                            src="/static/images/multiModel.png"
                                                            alt=""
                                                        />
                                                    </Popover>
                                                </span>
                                            ) : (
                                                <>
                                                    {detailShowConfigObj?.playBarShowEmotion ? (
                                                        <span
                                                            style={{ cursor: 'pointer' }}
                                                            // onClick={() => {
                                                            //     alert(itemIndex);
                                                            // }}
                                                        >
                                                            {item.emotionValue == 1 && (
                                                                <img
                                                                    style={{
                                                                        width: '10px',
                                                                        height: '10px',
                                                                    }}
                                                                    src="/static/images/positive.png"
                                                                    alt=""
                                                                />
                                                            )}
                                                            {item.emotionValue == 2 && (
                                                                <img
                                                                    style={{
                                                                        width: '10px',
                                                                        height: '10px',
                                                                    }}
                                                                    src="/static/images/positive.png"
                                                                    alt=""
                                                                />
                                                            )}
                                                            {item.emotionValue == 3 && (
                                                                <img
                                                                    style={{
                                                                        width: '10px',
                                                                        height: '10px',
                                                                    }}
                                                                    src="/static/images/positive.png"
                                                                    alt=""
                                                                />
                                                            )}
                                                            {item.emotionValue == -1 && (
                                                                <img
                                                                    style={{
                                                                        width: '10px',
                                                                        height: '10px',
                                                                    }}
                                                                    src="/static/images/negative.png"
                                                                    alt=""
                                                                />
                                                            )}
                                                            {item.emotionValue == -2 && (
                                                                <img
                                                                    style={{
                                                                        width: '10px',
                                                                        height: '10px',
                                                                    }}
                                                                    src="/static/images/negative.png"
                                                                    alt=""
                                                                />
                                                            )}
                                                            {item.emotionValue == -3 && (
                                                                <img
                                                                    style={{
                                                                        width: '10px',
                                                                        height: '10px',
                                                                    }}
                                                                    src="/static/images/negative.png"
                                                                    alt=""
                                                                />
                                                            )}
                                                        </span>
                                                    ) : (
                                                        ''
                                                    )}

                                                    <span
                                                        style={{ cursor: 'pointer' }}
                                                        // onClick={() => {
                                                        //     alert(itemIndex);
                                                        // }}
                                                    >
                                                        {item['indexPointTag'] && (
                                                            <Tooltip
                                                                placement="right"
                                                                title={
                                                                    <div
                                                                        style={{
                                                                            whiteSpace: 'pre-wrap',
                                                                        }}
                                                                    >
                                                                        {item['indexPointTag'].join(
                                                                            ','
                                                                        ) || ''}
                                                                    </div>
                                                                }
                                                            >
                                                                <img
                                                                    style={{
                                                                        width: '10px',
                                                                        height: '10px',
                                                                    }}
                                                                    src="/static/images/rulesTag.png"
                                                                    alt=""
                                                                />
                                                            </Tooltip>
                                                        )}
                                                    </span>

                                                    <span
                                                        style={{ cursor: 'pointer' }}
                                                        // onClick={() => {
                                                        //     alert(itemIndex);
                                                        // }}
                                                    >
                                                        {item['smartTag'] && (
                                                            <Tooltip
                                                                placement="right"
                                                                title={
                                                                    <div
                                                                        style={{
                                                                            whiteSpace: 'pre-wrap',
                                                                        }}
                                                                    >
                                                                        {item['smartTag'].join(
                                                                            ','
                                                                        ) || ''}
                                                                    </div>
                                                                }
                                                            >
                                                                <img
                                                                    style={{
                                                                        width: '10px',
                                                                        height: '10px',
                                                                    }}
                                                                    src="/static/images/qaRules.png"
                                                                    alt=""
                                                                />
                                                            </Tooltip>
                                                        )}
                                                    </span>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default React.memo(AudioStickers);

function getAudioStickerItemStyleModel(
    startPoint: Times['startPoint'],
    endPoint: Times['endPoint'],
    time: RoleTimes['voiceLength'],
    backgroundColor: string
): React.CSSProperties {
    var start = parseFloat(`${startPoint}`);
    var end = parseFloat(`${endPoint}`);
    var timeLength = parseFloat(`${time}`);
    if (isNaN(start) || isNaN(end) || isNaN(timeLength)) {
        // return String.htmlSafe("width:0%;left:0%");
        return {
            width: '0%',
            left: '0%',
        };
    } else {
        let letfPoint =
            timeLength <= 0 ? '0%' : Math.round((start / timeLength) * 10000) / 100.0 + '%';
        let width =
            timeLength <= 0 ? '0%' : Math.round(((end - start) / timeLength) * 10000) / 100.0 + '%';
        // return String.htmlSafe(`width:${width};left:${letfPoint};background:${backgroundColor}`);
        // console.log({width: width,
        //     left: letfPoint,
        //     backgroundColor: backgroundColor});
        return {
            width: width,
            left: letfPoint,
            backgroundColor: backgroundColor,
        };
    }
}
